import { QueryNormalizerProvider } from "@normy/react-query";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "@/routeTree.gen";
import { NotFound } from "./components/NotFound";
import { queryClient, TRPCProvider, trpc, trpcClient } from "./lib/trpcClient";

// Register things for typesafety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export const router = createRouter({
  context: {
    queryClient: queryClient,
    trpc,
  },
  defaultErrorComponent: ({ error }) => {
    if (error.message === "Unauthorized") {
      return <div>Unauthorized</div>;
    }
    return <div>Error: {error.message}</div>;
  },
  defaultNotFoundComponent: () => <NotFound />,
  defaultPreload: "intent",
  notFoundMode: "root",
  routeTree,
});

export function App() {
  return (
    <QueryNormalizerProvider queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <TRPCProvider queryClient={queryClient} trpcClient={trpcClient}>
          <RouterProvider router={router} />
        </TRPCProvider>
      </QueryClientProvider>
    </QueryNormalizerProvider>
  );
}
